import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },

  parrotS: {
    width: 250,
    height: 'auto',
  },
}));

export default useStyles;
